module.exports = __webpack_public_path__ + "media/images/icons/equipment-c4def54f3424335274901b34a82e3103.svg";